import type React from "react";
import {useCallback} from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {useNavigate, useParams} from "react-router-dom";

import {faCopy, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {useLevelV2} from "~/api/hooks/useLevelV2";
import {useCreateWipLevelV2} from "~/api/hooks/useWipLevelV2";
import CustomButton from "~/component/common/CustomButton";
import {auth} from "~/firebase/firebase";

const CloneButton: React.FC = () => {
  const {id: levelId} = useParams<{id: string}>();
  const [myUser] = useAuthState(auth);
  const {data: level} = useLevelV2({id: levelId});
  const navigate = useNavigate();

  const {mutateAsync: createWipLevel, isPending: isCreating} =
    useCreateWipLevelV2();

  const handleCloneLevel = useCallback(() => {
    if (!level || !myUser) return;
    const cloneData = {
      name: level.name + " Copy",
      creatorId: myUser.uid,
      data: level.data,
      createdAt: new Date(),
      updatedAt: new Date(),
    };
    createWipLevel({key: {}, data: cloneData}).then((res) =>
      navigate(`/create/${res}`),
    );
  }, [level, myUser, createWipLevel, navigate]);

  return (
    <CustomButton
      onClick={handleCloneLevel}
      aria-label="Clone Level"
      className="w-10 h-10 bg-orange-500 hover:bg-orange-600 rounded-lg transition-colors flex items-center justify-center"
    >
      {isCreating ? (
        <FontAwesomeIcon
          icon={faSpinner}
          spin
          size="xl"
          className="text-white"
        />
      ) : (
        <FontAwesomeIcon icon={faCopy} size="xl" className="text-white" />
      )}
    </CustomButton>
  );
};

export default CloneButton;
